export const LOAD_IMAGE = 'LOAD_IMAGE';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_COMPLETE = 'UPLOAD_COMPLETE';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';
export const INSERT_IMAGE = 'INSERT_IMAGE';
